import RiskSummaryEvalue from './RiskSummary/RiskSummaryEvalue';
import RiskSummaryMorningstar from './RiskSummary/RiskSummaryMorningstar';
import { Utils } from './Utils';
import Recommendations from './Recommendations/Recommendations';
import Policies from './Recommendations/ExistingPolicies/Policies';
import Policy from './Recommendations/ExistingPolicies/Policy';
import Contributions from './Recommendations/Contributions/Contributions';
import RecommendedPolicies from './Recommendations/RecommendedPolicies/RecommendedPolicies';
import Contribution from './Recommendations/Contributions/Contribution';
import Withdrawals from './Recommendations/Withdrawals/Withdrawals';
import Withdrawal from './Recommendations/Withdrawals/Withdrawal';
import { ManagePoliciesForms } from './ExistingPolicies/ManagePolicies';
import { PolicySummaryForms } from './ExistingPolicies/PolicySummary';
import Customer from './Customer/Customer';
import { PortfolioBuilderForms } from './PortfolioBuilder';
import { v2 } from './v2';

export default {
  RiskSummaryEvalue,
  RiskSummaryMorningstar,
  ManagePolicies: ManagePoliciesForms,
  Utils,
  PolicySummary: PolicySummaryForms,
  PortfolioBuilder: PortfolioBuilderForms,
  Recommendations,
  Policies,
  Policy,
  Contributions,
  Contribution,
  Withdrawals,
  Withdrawal,
  RecommendedPolicies,
  Customer,
  v2
};
